import numberShortFormat from "@/filters/numbers/numberShortFormat";
import dollarAmount from "@/filters/numbers/dollarAmount";
import commafy from "@/filters/numbers/commafy";
import percentage from "@/filters/numbers/percentage";

const installFilters = (app) => {
  app.config.globalProperties.$filters = {
    numberShortFormat: numberShortFormat,
    dollarAmount: dollarAmount,
    commafy: commafy,
    percentage: percentage,
  };
};

export default installFilters;
